module.exports = __webpack_public_path__ + "img/visaLogo.542a55ba.png";